/**
 * Verrou de contrôles pendant une requête : un double clic ou un second
 * changement ne doit pas envoyer deux fois la même opération.
 */

/** Tout contrôle de formulaire ou bouton. */
export interface Verrouillable {
  disabled: boolean;
}

/**
 * Désactive les contrôles le temps de `action`, puis leur rend l'état qu'ils
 * avaient, que l'action réussisse ou non. Rend le résultat de l'action.
 */
export async function avecVerrou<T>(controles: readonly Verrouillable[], action: () => Promise<T>): Promise<T> {
  const avant = controles.map((c) => c.disabled);
  for (const c of controles) c.disabled = true;
  try {
    return await action();
  } finally {
    controles.forEach((c, i) => {
      c.disabled = avant[i] ?? false;
    });
  }
}
